import { Controller } from "@hotwired/stimulus"
import { normalizeText, smartMatch } from "../../utils/smart_search"

export default class extends Controller {
  static targets = ["input", "item", "empty"]

  filter() {
    const query = normalizeText(this.inputTarget.value)

    if (!query) {
      this.itemTargets.forEach((el) => el.classList.remove("hidden"))
      this.emptyTargets.forEach((el) => {
        el.classList.add("hidden")
        el.classList.remove("flex")
      })
      return
    }

    let visibleCount = 0
    this.itemTargets.forEach((el) => {
      const name = el.dataset.searchName || ""
      const registration = el.dataset.searchRegistration || ""
      const match = smartMatch([name, registration], query)
      el.classList.toggle("hidden", !match)
      if (match) visibleCount++
    })

    this.emptyTargets.forEach((el) => {
      el.classList.toggle("hidden", visibleCount > 0)
      el.classList.toggle("flex", visibleCount === 0)
    })
  }
}
